import { FC } from 'react';
import { useSnapshot } from 'valtio';
import { useExclusions } from '../../../exclusions/actions/exclusions-actions';
import { onDisablePolicy } from '../actions/issues-exclusions-actions';
import DisablePolicyModal from '../components/IssueTableRow/DisablePolicyModal';
import {
  setExclusionPolicyComment,
  setPolicyDisableModal,
} from '../../active-issues/store-actions/issue-store-actions';
import IssuesStore from '../../active-issues/stores/issues-store';

const DisablePolicyContainer: FC<React.PropsWithChildren<unknown>> = () => {
  const { isDisablePolicyLoading } = useExclusions();

  const { policyDisableModal, selectedIssue } = useSnapshot(IssuesStore);

  const handleClose = () => {
    setPolicyDisableModal(false);
  };

  return (
    <DisablePolicyModal
      open={policyDisableModal}
      onCloseDisablePolicy={handleClose}
      handleDisablePolicy={onDisablePolicy}
      isLoading={isDisablePolicyLoading}
      policyName={selectedIssue?.policy.name}
      excludeComment={selectedIssue?.policy.comment}
      setExcludeComment={setExclusionPolicyComment}
    />
  );
};

export default DisablePolicyContainer;
